import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListDatasetsParams } from './models/list-datasets-params.model';
import { ListDatasetsResponse } from './models/list-datasets-response.model';

@Injectable({
    providedIn: 'root',
})
export class DatasetsService {
    public constructor(private readonly httpClient: HttpClient) {}

    public listDatasets(businessDomainId: string, params: ListDatasetsParams = {}): Observable<ListDatasetsResponse> {
        let httpParams = new HttpParams();
        if (params.pageNumber !== undefined) {
            httpParams = httpParams.set('pageNumber', params.pageNumber);
        }
        if (params.pageSize !== undefined) {
            httpParams = httpParams.set('pageSize', params.pageSize);
        }
        if (params.runMode !== undefined) {
            httpParams = httpParams.set('runMode', params.runMode);
        }
        if (params.searchValue !== undefined) {
            httpParams = httpParams.set('searchValue', params.searchValue);
        }

        return this.httpClient.get<ListDatasetsResponse>(`business-domains/${businessDomainId}/datasets`, {
            params: httpParams,
        });
    }
}
